import React, {Component} from 'react'
import './App.css'
import {Route, Switch, BrowserRouter} from "react-router-dom";
import ReceiptSignature from "./Components/receipt-signature/ReceiptSignature";
import Feedback from "./Components/feedback/Feedback";
import Device from "./Components/Device/Device";
import Slider from "./Components/Slider/Slider";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class App extends Component {
    render() {
        return (
            <div>
                <ToastContainer/>
                <BrowserRouter>
                    <Switch>
                        <Route path="/" exact component={Device}/>
                        <Route path="/slider" component={Slider}/>
                        <Route path="/receipt" component={ReceiptSignature}/>
                        <Route path="/feedback" component={Feedback}/>
                    </Switch>
                </BrowserRouter>
            </div>
        );
    }
}

export default App;
